import { useMutation, useQueryClient } from '@tanstack/react-query';
import { queryKeys, missionControlService } from '@v2/services';
import type { ManagePluginPayload } from '@v2/services/missionControl';
import type { MissionControlPlugin } from '@v2/types';

export type { ManagePluginPayload } from '@v2/services/missionControl';

interface UseManagePluginResult {
  managePlugin: (payload: ManagePluginPayload) => Promise<MissionControlPlugin | null>;
  loading: boolean;
  error: string | null;
}

export function useManagePlugin(): UseManagePluginResult {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: missionControlService.managePlugin,
    onSuccess: () => {
      queryClient.invalidateQueries(queryKeys.missionControl.plugins.all);
    },
  });

  const managePlugin = async (
    payload: ManagePluginPayload
  ): Promise<MissionControlPlugin | null> => {
    try {
      return await mutation.mutateAsync(payload);
    } catch {
      return null;
    }
  };

  return {
    managePlugin,
    loading: mutation.isLoading,
    error: mutation.error instanceof Error ? mutation.error.message : null,
  };
}

export default useManagePlugin;
